<template>
  <Wrapper
      @open="onClick"
      :icon="ICONS.clock"
      label="Время"
      code="time"
  >
    <DatetimeView
        :timeAccent="true"
        :value="deliveryDate"
        class="flex q-gutter-sm"
    />
  </Wrapper>
</template>

<script setup lang="ts">

import {VOrderSectionProps, vorderSectionPropsDefault} from "./util";
import Wrapper from "./Wrapper/Wrapper.vue";
import {storeToRefs} from "pinia";
import {useStackRouter} from "@/packages/stack-router/hooks/useStackRouter";
import TimeDialog from "@/components/Shop/VOrder/ui/Dialog/Time.vue";
import {VOrderDialogProps} from "@/components/Shop/VOrder/ui/Dialog/hook";
import {ICONS} from "@/assets/icons";
import DatetimeView from "@/components/Ui/DatetimeView.vue";
import {useVorderState} from "@/modules/shop/store/vorder-state";

const vorderState = useVorderState()

const {attrs, deliveryDate} = storeToRefs(vorderState)

const props = withDefaults(defineProps<VOrderSectionProps>(), {
  ...vorderSectionPropsDefault,
})

const {} = props

const stackRouter = useStackRouter()

const onClick = () => {
  stackRouter.getStack()?.push<VOrderDialogProps>(TimeDialog, {
    ...props
  })
}

</script>

<style>

</style>
